import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@app/core';
import { HomeRoutingModule } from '@app/home/home-routing.module';
import { HomeComponent } from '@app/home/home.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProfileModule } from '@app/profile/profile.module';
import { BeneficiaryModule } from '@app/beneficiary/beneficiary.module';
import { PreferencesModule } from '@app/preferences/preferences.module';
import { StatementsModule } from '@app/statements/statements.module';
import { BulkemailModule } from '@app/bulkemail/bulkemail.module';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import { DashboardModule } from '@app/dashboard/dashboard.module';
import { GoogleChartsModule } from '../../../node_modules/angular-google-charts';
import { BulknotificationModule } from '@app/bulknotification/bulknotification.module';


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    NgbModule,
    CoreModule,
    ProfileModule,
    BeneficiaryModule,
    PreferencesModule,
    StatementsModule,
    BulkemailModule,
    DashboardModule,
    BulknotificationModule,
    HomeRoutingModule,
    Ng4LoadingSpinnerModule.forRoot(),
    GoogleChartsModule
  ],
  declarations: [
    HomeComponent
  ],
  providers: [
  ]
})
export class HomeModule { }
